import styled from 'styled-components'

import chevronDown from '../../../assets/icons/chevron-down.svg'
import { CustomButton } from '../../../styles/global'

export const SolicitationButton = styled(CustomButton)`

`

export const SolicitationList = styled.div`
  width: 100%;
  position: relative;
  margin-top: 25px;
`

export const SolicitationTitle = styled.h3`
  font-size: 24px;
  font-weight: 700;
  width: 100%;
  text-align: center;
  letter-spacing: 0.96px;
  padding-bottom: 8px;
  border-bottom: 1px solid #999999;
`

export const OverbookInfo = styled.div`
  display: none;
  padding: 0px 30px 30px ;
  background-color: #ededed;
  border-radius: 0 0 4px 4px;
  transition: .3s;
  span {
    display: block;
    margin-bottom: 20px;
    color: #555555;
  }
  button {
    margin-bottom: 0;
  }
`

export const OverbookButton = styled(CustomButton)`
  background-color: #ededed;
  color: #000000;
  margin-bottom: 0;
  ${`background-image: url(${chevronDown});`}
  background-repeat: no-repeat;
  background-size: 24px;
  background-position-x: 95%;
  background-position-y: center;
  border: none;
  border-radius: 4px 4px  0 0 ;
`
